export default __webpack_public_path__ + "static/media/cootz.0d203a95.svg";